module.exports = __webpack_public_path__ + "img/arrow_up_3.3477d5ac.svg";